import { AdminComponent } from '~/components/admin-component/admin-component';

export const ContractTypes = () => (
  <AdminComponent
    componentName="ContractTypes"
    title="Contract Types"
  />
);
